import { useGateways } from "core/gateways-context";
import { OrgUnitDto } from "core/types/orgUnit.types";

import { HttpError } from "@bps/http-client";
import { DefinedInitialDataOptions, useQuery } from "@tanstack/react-query";

import {
  AppointmentTypeTGArgs,
  AppointmentTypeTGDto,
  TenantProviderDto
} from "./tenant.dtos";

const CacheKeys = {
  OrgUnits: "orgUnits",
  Providers: "providers",
  LicenceMappings: "licenceMappings",
  AppointmentTypesTG: "appointmentTypesTG"
};

export const useOrgUnitsQuery = (
  options?: DefinedInitialDataOptions<OrgUnitDto[], HttpError>
) => {
  const { tenantApi } = useGateways();
  return useQuery<OrgUnitDto[], HttpError>({
    queryKey: [CacheKeys.OrgUnits],
    queryFn: tenantApi.getOrgUnits,
    ...options
  });
};

export const useTenantProvidersQuery = (
  options?: DefinedInitialDataOptions<TenantProviderDto[], HttpError>
) => {
  const { tenantApi } = useGateways();
  return useQuery({
    queryKey: [CacheKeys.Providers],
    queryFn: tenantApi.getTenantProviders,
    ...options
  });
};

export const useAppointmentTypesTG = (
  appointmentTypeArgs?: AppointmentTypeTGArgs
) => {
  const { tenantApi } = useGateways();

  // Measure to ensure requests with the same id's but different order aren't considered as a new query
  const sortedIds = [...(appointmentTypeArgs?.appointmentTypeIds ?? [])].sort(
    (a, b) => (a < b ? -1 : 1)
  );

  return useQuery<AppointmentTypeTGDto[], HttpError>({
    queryKey: [CacheKeys.AppointmentTypesTG, sortedIds],
    queryFn: async () =>
      await tenantApi.getAppointmentTypesTG(appointmentTypeArgs)
  });
};
